"use strict";

import "core-js/modules/es.symbol.description.js";
import { CDN } from '@autoguru/global-configs';
import { Box, Column, Columns, Stack, Text } from '@autoguru/overdrive';
import { NextPicture } from '@autoguru/picture';
import { HeadingSection } from '~/src/components/HeadingSection/HeadingSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const arrUSP = [{
  imgPath: 'icon-less calls.svg',
  altText: 'less calls',
  title: 'Less calls',
  description: '95% reduction in fleet approval calls'
}, {
  imgPath: 'icon-digital- approvals.svg',
  altText: 'quicker approvals',
  title: 'Quicker approvals',
  description: 'Bookings can be managed online'
}, {
  imgPath: 'icon-faster-payments.svg',
  altText: 'faster payments',
  title: 'Faster payment',
  description: 'Get paid within days instead of weeks or months'
}];
export const OnePortalUSP = ({
  size,
  isDesktop
}) => {
  const marginY = isDesktop ? '6' : '4';
  const paddingX = isDesktop ? 'none' : '1';
  const paddingY = isDesktop ? '6' : '4';
  const uspImgSize = isDesktop ? 96 : 64;
  const uspSpacingY = isDesktop ? '3' : '1';
  return /*#__PURE__*/_jsxs(Box, {
    marginY: marginY,
    paddingX: paddingX,
    style: {
      maxWidth: '1200px',
      margin: '0 auto'
    },
    children: [/*#__PURE__*/_jsx(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "7",
      children: /*#__PURE__*/_jsx(HeadingSection, {
        title: "One portal to make fleet servicing easy",
        size: size
      })
    }), /*#__PURE__*/_jsx(Columns, {
      children: arrUSP.map(usp => /*#__PURE__*/_jsx(Column, {
        grow: true,
        noShrink: true,
        width: ['full', '1/3'],
        paddingY: paddingY,
        paddingX: "6",
        backgroundColour: "white",
        borderRadius: "1",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsxs(Stack, {
          space: uspSpacingY,
          children: [/*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(Box, {
              position: "relative",
              children: /*#__PURE__*/_jsx(NextPicture, {
                lazy: true,
                backgroundColor: "transparent",
                altText: `${usp.altText}`,
                width: uspImgSize,
                quality: 70,
                height: "auto",
                sizes: "(max-width: 1023px) 64px, (min-width: 1024px) 96px",
                aspectRatio: 1,
                src: `${CDN}/images/nz/landing/${usp.imgPath}`
              })
            })
          }), /*#__PURE__*/_jsx(Text, {
            strong: true,
            as: "p",
            size: "6",
            align: "center",
            children: usp.title
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            size: "4",
            align: "center",
            children: usp.description
          })]
        })
      }, usp.imgPath))
    })]
  });
};